import React from 'react'

function tune(props) {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}
        {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M8 4H9.33333V2.66667H12V1.33333H9.33333V0H8V4ZM2.66667 4V5.33333H0V6.66667H2.66667V8H4V4H2.66667ZM6.66667 10.6667V12H5.33333V8H6.66667V9.33333H12V10.6667H6.66667ZM0 10.6667V9.33333H4V10.6667H0ZM12 5.33333V6.66667H5.33333V5.33333H12ZM6.66667 1.33333H0V2.66H6.66667V1.33333Z" fill="#737B81"/>
        </svg>
        
    )
}

export default tune
